var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutWithContainer",
    [
      _vm.$wait.is("fetching preview resource")
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("Spinner", { attrs: { height: 40, width: 40 } })],
            1
          )
        : _vm.resource
        ? [
            _vm.resource.event
              ? _c(
                  "template",
                  { slot: "header" },
                  [
                    _c(
                      "ContentHeader",
                      {
                        attrs: {
                          title: _vm.resource.name,
                          "back-link": `/documents/conferences/${_vm.resource.event.id}`,
                          "back-link-title": `Back to ${_vm.resource.event.eventName}`,
                        },
                      },
                      [
                        _c(
                          "template",
                          { slot: "actions" },
                          [
                            _vm.resource.can.edit
                              ? _c(
                                  "router-link",
                                  {
                                    staticClass: "btn",
                                    attrs: {
                                      to: {
                                        name: "edit-conference-document",
                                        props: { id: _vm.id },
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        Edit\n                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.resource.attachment &&
                        _vm.resource.attachment.filename !== "invalid"
                          ? _c("template", { slot: "extra" }, [
                              _c(
                                "div",
                                { staticClass: "extra" },
                                [
                                  _c("span", { staticClass: "filename" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.resource.attachment.raw.filename
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("DataList", {
                                    attrs: {
                                      items: [
                                        {
                                          title: "Last Updated",
                                          value: _vm.resource.updatedAt,
                                          icon: "calendar",
                                          isSector: false,
                                        },
                                        {
                                          title: "Conference",
                                          value: _vm.resource.event.eventName,
                                          icon: "location",
                                          isSector: false,
                                        },
                                      ],
                                    },
                                  }),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.possibleSectors
              ? _c("aside", { staticClass: "form", attrs: { id: "filters" } }, [
                  _c(
                    "div",
                    {
                      staticClass: "form__group",
                      staticStyle: { "max-width": "30rem" },
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filter,
                              expression: "filter",
                            },
                          ],
                          staticClass: "form__control",
                          attrs: { name: "filter" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.filter = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "all" } }, [
                            _vm._v("All"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.possibleSectors, function (name, id) {
                            return _c(
                              "option",
                              {
                                attrs: { id: `filter-${id}` },
                                domProps: { value: id },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(name) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form__label",
                          attrs: { for: "filter" },
                        },
                        [_vm._v("Filter by sector:")]
                      ),
                      _vm._v(" "),
                      _vm.filter && _vm.filter !== "all"
                        ? _c(
                            "a",
                            {
                              staticClass: "form__clear",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return (() => (_vm.filter = "all")).apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                    Clear\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.standoutDocuments && _vm.standoutDocuments.length > 0
              ? _c("section", [
                  _c("h3", { staticClass: "h2" }, [
                    _vm._v("Key Stand out Transactions"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "grid grid--cards" },
                    _vm._l(_vm.standoutDocuments, function (item) {
                      return _c(
                        "div",
                        { staticClass: "col-sm-6" },
                        [_c("StandoutCard", { attrs: { item: item } })],
                        1
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.activeProjectsMandates && _vm.activeProjectsMandates.length > 0
              ? _c("section", [
                  _c("h3", { staticClass: "h2" }, [
                    _vm._v("Active projects/mandates"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "grid grid--cards" },
                    _vm._l(_vm.activeProjectsMandates, function (item) {
                      return _c(
                        "div",
                        { staticClass: "col-sm-6" },
                        [_c("GenericDocumentCard", { attrs: { item: item } })],
                        1
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.activeProspectsOpportunities &&
            _vm.activeProspectsOpportunities.length > 0
              ? _c("section", [
                  _c("h3", { staticClass: "h2" }, [
                    _vm._v("Active prospects/opportunities"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "grid grid--cards" },
                    _vm._l(_vm.activeProspectsOpportunities, function (item) {
                      return _c(
                        "div",
                        { staticClass: "col-sm-6" },
                        [_c("GenericDocumentCard", { attrs: { item: item } })],
                        1
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.activeProspectsOpportunities &&
            _vm.potentialMAMethodTargets.length > 0
              ? _c("section", [
                  _c("h3", { staticClass: "h2" }, [
                    _vm._v("Potential MA Method Targets"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "grid grid--cards" },
                    _vm._l(_vm.potentialMAMethodTargets, function (item) {
                      return _c(
                        "div",
                        { staticClass: "col-sm-6" },
                        [_c("GenericDocumentCard", { attrs: { item: item } })],
                        1
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.resource.status !== 2
              ? _c("section", { staticClass: "create" }, [
                  _vm.resource.can.delete
                    ? _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "wait",
                              rawName: "v-wait:disabled",
                              value: [
                                "saving preview resource",
                                "deleting preview resource",
                              ],
                              expression:
                                "['saving preview resource', 'deleting preview resource']",
                              arg: "disabled",
                            },
                          ],
                          staticClass: "btn btn--danger",
                          on: {
                            click: function ($event) {
                              return _vm.showDeleteModal()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                Delete Document\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resource.can.approve
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn--primary",
                          attrs: {
                            to: {
                              name: "create-event-document",
                              props: { event_id: _vm.id },
                            },
                          },
                          on: { click: _vm.submitDocument },
                        },
                        [
                          _vm._v(
                            "\n                Submit Document\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]
        : _c("div", { staticClass: "error" }, [
            _c("span", { staticClass: "h2" }, [
              _vm._v("Unable to load document."),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--link",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.fetchResource.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Retry")]
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }